const hostname =
  typeof window !== "undefined" && window?.location?.hostname
    ? window.location.hostname
    : "";

const KEYSETS_BY_ENV_SUFFIX = {
  DOSINA: new Set(["newtms.dosina.no", "tms.dosina.no", "qatms.dosina.no"]),
  BECONNECTED: new Set(["tms.beconnected.no", "newtms.beconnected.no", "test-newtms.beconnected.no"]),
  KANHASOFT66: new Set(["66.228.60.166"]),
};

const BASE_KEYS = [
  "REACT_APP_API_URL",
  "REACT_APP_FLAG_URL",
  "REACT_APP_LANG_FLAG",
  "REACT_APP_FILEPATH",
  "REACT_APP_DROPDOWN_FLAG_URL",
];

function pickEnvSuffix(host) {
  for (const [suffix, hosts] of Object.entries(KEYSETS_BY_ENV_SUFFIX)) {
    if (hosts.has(host)) return suffix;
  }
  return null;
}

function buildConfigFromEnv(suffix) {
  const cfg = {};
  for (const key of BASE_KEYS) {
    const envKey = suffix ? `${key}_${suffix}` : key;
    cfg[key] = process.env[envKey];
  }
  return cfg;
}

const APP_CONFIG_URL_ENV = buildConfigFromEnv(pickEnvSuffix(hostname));

export { pickEnvSuffix };
export default APP_CONFIG_URL_ENV;